export const formatarCombos = (itensFormatCombo, itens) => {
  return (itensFormatCombo || [])
    .map(c => {
      const idsCombo = Array.isArray(c.idcombopromocional_itens)
        ? c.idcombopromocional_itens
        : [];

      const produtosCombo = itens.filter(p =>
        idsCombo.includes(p.id_combo_item)
      );

      const preco = produtosCombo.reduce(
        (acc, p) => acc + p.preco * p.quantidade,
        0
      );

      return {
        ...c,
        errorImg: false,
        produtos: produtosCombo,
        preco
      };
    })
    .filter(c => c.produtos && c.produtos.length > 0);
};
